<div id="AtjDeletePopUp" class="Atj_overlay " (click)="$event.stopPropagation(); dismiss()">
    <div id="Atj_popup" class="Atj_popup ATJ-slide-bottom" (click)="$event.stopPropagation();">
        <div class="headding"> {{ title }}</div>
        <a class="close" (click)="dismiss()">&times;</a>
        <hr style="margin-bottom: 0px;" >
        <div class="Atj_content">
            {{ message }}<br>
            <div style="float: right;">
                <button class="btn btn-sm btn-success" (click)="decline()">{{ btnCancelText }}</button> &nbsp;
                <button class="btn btn-sm btn-danger" (click)="accept()">{{ btnOkText }} </button>
            </div>
        </div>
    </div>
</div>